import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
 
const appRoot =
  document.getElementById("ecommerce-wrap") || 
  document.getElementById("checkout-and-payment-page") ||
  document.getElementById("thankyou") ||
  document.getElementById("invoice-thankyou") ||
  document.getElementById("prepaid-ticket-thankyou");
 
if (appRoot) {
  const root = ReactDOM.createRoot(appRoot);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}